import { createSlice } from '@reduxjs/toolkit';

const settingsSlice = createSlice({
	name: 'settings',
	initialState: {
		isUsingAPICalls: 0
	},
	reducers: {
		setUsingAPICall(state) {
			state.isUsingAPICalls += 1
		},
	},
});

export const { setUsingAPICall } = settingsSlice.actions;
export default settingsSlice.reducer;
